/** NextAuth `useSession()` status values. */
export const SESSION_STATUS = {
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
  LOADING: 'loading',
} as const;

/** NextAuth provider ID for Microsoft Entra External ID. */
export const AUTH_PROVIDER = 'entra-external-id' as const;

/** Query-string error codes used by linked-account auth callbacks. */
export const AUTH_CALLBACK_ERROR = {
  MISSING_PARAMS: 'missing_params',
  LINK_FAILED: 'link_failed',
} as const;
